import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import { useContext, useEffect, useState } from 'react';
import UserProfile from './UserProfile';
import BillingPage from './BillingPage';
import { UserContext } from '../Context/UserContext';
import { pricingData } from '../Common/PricingData';
import { handleRazorpayPayment } from '../Utils/Razorpay';
import FeedbackPopup from '../Common/FeedbackPopup';
import FooterComponent from '../Common/SlidesFooterComponent';
import { sentryLog } from '../Utils/SentryLog';
import { getLqzyParams } from '../Utils/GetLqzyParams';
import { toast } from 'react-toastify';
import { slidesExtensionPricingData } from '../Common/SlidesExtensionPricingData';
import ExtensionNavbar from './SlidesExtensionNavbar';
import axios from 'axios';
/* global gtag */
/* global gtag_report_conversion */

const APP_BASE_URL = process.env.NODE_ENV === 'development' 
    ? "http://localhost:3000" 
    : "https://www.easyimagetotext.com";

const API_BASE_URL = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_LOCAL_API_URL : process.env.REACT_APP_API_URL;

const lemonSqzyQueryParams = getLqzyParams();

const isLemonSqueezyTestMode = false;
//pay links
const topUp100PayLink = !isLemonSqueezyTestMode ? `https://easyimagetotext.lemonsqueezy.com/checkout/buy/7206b24e-bec3-4f97-97f7-07d892f04f79?embed=1&enabled=1998633` : `https://easyimagetotext.lemonsqueezy.com/checkout/buy/cb1661db-0ded-4982-a9c1-29d9bfb94f92?embed=1&enabled=1998720`;
const topUp500PayLink = !isLemonSqueezyTestMode ? `https://easyimagetotext.lemonsqueezy.com/checkout/buy/0311330c-0fe4-4c23-a73a-291e5546abbc?embed=1&enabled=1998634` : `https://easyimagetotext.lemonsqueezy.com/checkout/buy/f4845a56-37d4-4497-bea7-df9fa9e33ec7?embed=1&enabled=1998721`;
const topUp1000PayLink = !isLemonSqueezyTestMode ? `https://easyimagetotext.lemonsqueezy.com/checkout/buy/614bec5e-55c1-42bc-b07f-e66dca1d7dec?embed=1&enabled=1998635` : `https://easyimagetotext.lemonsqueezy.com/checkout/buy/f37e724f-602e-44bb-9eef-55f737e70277?embed=1&enabled=1998722`;

const monthly100PayLink = !isLemonSqueezyTestMode ? `https://easyimagetotext.lemonsqueezy.com/checkout/buy/5d42460a-4d77-4374-a27f-d9b4deabfed5?embed=1&enabled=1998636` : `https://easyimagetotext.lemonsqueezy.com/checkout/buy/0215e14e-b135-46fd-8931-b5db01382d5a?embed=1&enabled=1998723`;
const monthly500PayLink = !isLemonSqueezyTestMode ? `https://easyimagetotext.lemonsqueezy.com/checkout/buy/9b4ec8db-bae9-4f4f-8089-bc95f0eff00c?embed=1&enabled=1998637` : `https://easyimagetotext.lemonsqueezy.com/checkout/buy/7980cf34-8652-49c9-a0e4-9e7641390384?embed=1&enabled=1998724`;
const monthly1000PayLink = !isLemonSqueezyTestMode ? `https://easyimagetotext.lemonsqueezy.com/checkout/buy/fc624cf5-d61c-4122-a836-6561e02d5164?embed=1&enabled=1998638` : `https://easyimagetotext.lemonsqueezy.com/checkout/buy/b76c1eb1-e7fd-4717-a771-68ca1d0fbd2a?embed=1&enabled=1998725`;
//

function SlidesExtensionPricingPage({ isIndianUser }){

    const { user, setUser } = useContext(UserContext);
    
    const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);
    const [userDiscountCode, setUserDiscountCode] = useState("");
    const [isDiscountApplied, setIsDiscountApplied] = useState(false);
    const [fromExtension, setFromExtension] = useState(false);
    const [numOfTopUpCredits, setNumOfTopUpCredits] = useState(100);
    const [numOfSubCredits, setNumOfSubCredits] = useState(100);
    const [topUpAmtPerImg, setTopUpAmtPerImg] = useState('0.15');//need to cross-check with rates and plans as of todays date
    const [subscriptionAmtPerImg, setSubscriptionAmountPerImg] = useState('0.1');//need to cross-check with rates and plans as of todays date
    const [topUpPayLink, setTopUpPayLink] = useState(topUp100PayLink);
    const [subscriptionPayLink, setSubscriptionPayLink] = useState(monthly100PayLink);

    const isShowConsole = process.env.NODE_ENV === 'development';

    const location = useLocation();
    const navigate = useNavigate();

    isShowConsole && console.log('pricing page user check: ', user);
    isShowConsole && console.log("Current Path:", location.pathname); 

    useEffect(() => {
        document.title = "Convert PDF to Google Slides in 1 click | PDF to Google Slides Converter";
        const planAmount = localStorage.getItem("pendingPlanAmount");
        const planType = localStorage.getItem("pendingPlanType");
        const pendingSheetsPlanLink = localStorage.getItem("pendingSheetsPlanLink");

        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('source') === 'extension' || urlParams.get('source') === 'slides-extension') {
            sessionStorage.setItem('fromExtension', 'true');
            setFromExtension(true);
        }
      
        if (planAmount && planType) {
            try {
                handleRazorpayPayment(Number(planAmount), planType, setUser, openContactForm);
            } catch (err) {
                isShowConsole && console.error('handleRazorpayPayment failed in useEffect:', err);
                sentryLog(`PricingPage.js - useEffect RazorpayPayment failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
            }
            localStorage.removeItem("pendingPlanAmount");
            localStorage.removeItem("pendingPlanType");
        }
        if(pendingSheetsPlanLink){
            try {
                window.open(
                    pendingSheetsPlanLink,
                    "_blank"
                );
            } catch (err) {
                isShowConsole && console.error('pending paypal plan link failed to open in useEffect in PricingPage.js:', err);
                sentryLog(`PricingPage.js - useEffect pending paypal plan link open failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
            }
            localStorage.removeItem("pendingSheetsPlanLink");
        }
    }, []);

    const showSuccessToast = () => {
      try{
        toast.success(
          <div className='verificationSuccessToast'>
            <span>
                Payment successful! 🎉 Refresh the add-on sidebar to see your credits. 
            </span>
          </div>,
          {
            className: "verificationSuccessToastContainer",
            autoClose: 4000, 
            closeButton: false,
            onClose: () => {
                if (sessionStorage.getItem('fromExtension') === 'true') {
                    sessionStorage.removeItem('fromExtension');
                    setTimeout(() => window.close(), 100); 
                }
            }
          }
        );
      }catch(err){
        isShowConsole && console.error("error in showSuccessToast: ", err);
        sentryLog(`Razorpay.js - showSuccessToast failed: ${err?.message || err}`);
      }
    }

    useEffect(() => {
        const shouldNotifyUserUpgrade = localStorage.getItem("shouldNotifyUserUpgrade");

        if(shouldNotifyUserUpgrade === 'true'){
            showSuccessToast();
            localStorage.removeItem("shouldNotifyUserUpgrade");
        }
        
    }, [user])

    const openContactForm = e => {
        try{
            navigate(`/slides-extension-contact-us${lemonSqzyQueryParams}`);
        }catch(err){
            isShowConsole && console.error('error in openContactForm method: ', err);
            sentryLog(`PricingPage.js - openContactForm failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
        }
    }

    const handleTopUpCreditsChange = e => {
        try{
            let newPlanPrice = (e.target.value == 100 ? '0.15' : e.target.value == 500 ? '0.08' : e.target.value == 1000 ? '0.07' : '');
            let newPayLink = (e.target.value == 100 ? topUp100PayLink : e.target.value == 500 ? topUp500PayLink : e.target.value == 1000 ? topUp1000PayLink : '');
            setTopUpPayLink(newPayLink);
            setTopUpAmtPerImg(newPlanPrice);
            setNumOfTopUpCredits(e.target.value);
        }catch(err){
            isShowConsole && console.error('error in handleTopUpCreditsChange method: ', err);
            sentryLog(`PricingPage.js - handleTopUpCreditsChange failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
        }
    }

    const handleSubCreditsChange = e => {
        try{
            let newPlanPrice = (e.target.value == 100 ? '0.1' : e.target.value == 500 ? '0.05' : e.target.value == 1000 ? '0.04' : '');
            let newPayLink = (e.target.value == 100 ? monthly100PayLink : e.target.value == 500 ? monthly500PayLink : e.target.value == 1000 ? monthly1000PayLink : '');
            setSubscriptionPayLink(newPayLink);
            setSubscriptionAmountPerImg(newPlanPrice);
            setNumOfSubCredits(e.target.value);
        }catch(err){
            isShowConsole && console.error('error in handleSubCreditsChange method: ', err);
            sentryLog(`PricingPage.js - handleSubCreditsChange failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
        }
    }

    const showErrorToast = e => {
        try{
            toast.error(
            <div className='paymentFailureToast'>
                <span> 
                Something went wrong. Please try again, or <a href="#" onClick={(e) => { e.preventDefault(); openContactForm();}}>Contact Support</a> for help.
                </span>
            </div>,
            {
                className: "paymentFailureToastContainer",
                autoClose: 4000, 
                closeButton: false
            }
            );
        }catch(err){
            isShowConsole && console.error("error in showErrorToast: ", err);
            sentryLog(`SlidesExtensionPricingPage.js - showErrorToast failed: ${err?.message || err}`);
        }
    }

    const handleManageSubscription = async(e) => {
        try{
            const params = {
                forSlidesExtension: true
            };

            const res = await axios.get(`${API_BASE_URL}/api/get-customer-portal-link`, { withCredentials: true, params: params });
            
            let customerPortalUrl = res?.data?.portalUrl;
            if(customerPortalUrl){
                window.open(customerPortalUrl, '_blank');
            }
        }catch(err){
            isShowConsole && console.error('error in handleManageSubscription method: ', err);
            showErrorToast();
            sentryLog(`BillingPage.js - handleManageSubscription failed: ${err?.message || err}`);
        }
    }

    const openTextOcrPricingPage = e => {
        try{
            window.open(
                'https://www.easyimagetotext.com/pricing',
                "_blank"
            );
        }catch(err){
            isShowConsole && console.error('error in openTextOcrPricingPage method: ', err);
            sentryLog(`PricingPage.js - openTextOcrPricingPage failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
        }
    }

    const initateCrispChatbot = e => {
        try{
            // If Crisp is already loaded, open it immediately
            if (window.$crisp) {
                window.$crisp.push(["do", "chat:open"]);
            } else {
            // If not loaded yet, wait for the ready event
                window.CRISP_READY_TRIGGER = () => {
                    window.$crisp.push(["do", "chat:open"]);
                };
            }
        }catch(err){
            isShowConsole && console.error('error in initateCrispChatbot method: ', err);
            sentryLog(`PricingPage.js - initateCrispChatbot failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
        }
    }

    const openTableOcrFAQPage = e => {
        try{
            window.open(
                'https://www.easyimagetotext.com/sheets-extension-faq',
                "_blank"
            );
        }catch(err){
            isShowConsole && console.error('error in openTableOcrFAQPage method: ', err);
            sentryLog(`PricingPage.js - openTableOcrFAQPage failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
        }
    }

    const pricingElements = (user !== undefined) ? slidesExtensionPricingData.map((ele, idx) => {

        const isFeatures = ele.title === 'Features';
        let featuresList;
        if(isFeatures){
            featuresList = ele.features.map((feat, idx) => <li key={idx} style={{whiteSpace: 'normal'}}>{feat}</li>)
        }
        const isSubscription = ele.title === 'Subscription Plans';
        const isTopUp = ele.title === 'Top Up Plans';
        const perVal = ele.title === "Pro Weekly" ? 'week' : ele.title === 'Pro Monthly' ? 'month' : ele.title === 'Pro Yearly' ? 'year' : '';
        const billingPeriodInfo = ele.title === "Pro Weekly" ? 'weekly' : ele.title === 'Pro Monthly' ? 'monthly' : ele.title === 'Pro Yearly' ? 'yearly' : '';
        const extractionMsg = ele.title === 'Free' ? (ele.features.usageLimit + ' extractions per day') : (ele.features?.usageLimit + ' Extractions & Translations');
        const validityMsg = ele.title === "Pro Weekly" ? 'Valid for 7 days' : ele.title === 'Pro Monthly' ? 'Valid for 30 days' : ele.title === 'Pro Yearly' ? 'Valid for 365 days' : '';
        const billingMsg = ele.title === "Pro Weekly" ? 'Valid for 7 days' : ele.title === 'Pro Monthly' ? 'Billed monthly' : ele.title === 'Pro Yearly' ? 'Billed yearly' : '';

        const showActiveMsg = false;
        // (
        //     (isFeatures && user && !user.isPremium) ||
        //     (user?.isPremium && user?.planType === ele.title)
        //   );

        const currencySymbol = "$";//isIndianUser === null || isIndianUser ? '₹' : '$';
        const rate = ele.foreignRate;//isIndianUser === null || isIndianUser ? ele.rate : ele.foreignRate;

        const showTagline = ele.title === 'Pro Monthly' || ele.title === 'Pro Yearly';
        const tagLine = ele.title === 'Pro Monthly' ? 'Most popular' : ele.title === 'Pro Yearly' ? 'Best Value' : '';

        const planPrice = isSubscription ? subscriptionAmtPerImg : isTopUp ? topUpAmtPerImg : '';

        return(
            <div style={{overflowY: 'auto'}} className={`planContainer ${ele.title} ${(user?.isSlidesExtPremium && isSubscription) ? 'extPremium' : ''}`} key={idx}>
                {showTagline && <div className='tagLine'>{tagLine.toUpperCase()}</div>}
                <div className='planNameDiv'>
                    <div className='planName'>{ele.title}</div>
                    <div className='planDesc sheetsAddon'>{isSubscription ? "(Valid for 30 days, auto-renews until cancelled)" : isTopUp ? "(Valid for lifetime)" : ""}</div>
                    {/* {isFeatures ? (showActiveMsg && <div className={`activeMsg`}>(Active)</div>) : <div className={`activeMsg ${showActiveMsg ? 'show' : 'hide'}`}>(Active)</div>} */}
                </div>
                {!isFeatures && (isIndianUser !== null) && <div style={{display: 'none'}} className={`planRate ${user?.isSlidesExtPremium ? '' : ''}`}>
                    <div className='val'>{currencySymbol}{planPrice}</div>
                    <div className='duration'>/Credit</div>
                </div>}
                {/* {isSubscription && <div style={{opacity: 1.0, fontSize: '13px', margin: '20px 0px 20px 0px'}} className={`billingPeriodInfo ${user?.isSlidesExtPremium ? '' : ''}`}>( Auto-renews every month until you cancel )</div>} */}
                {!isFeatures && isSubscription && <div className="options-wrapper">
                    <div className='options-container'>
                        {ele.plans.map((option, index) => (
                            <div className='option-container'>
                                <label key={index} className="radio-label">
                                    <div className='lhs'>
                                        <input
                                            type="radio"
                                            name="subscription-option"
                                            value={option.credits}
                                            checked={numOfSubCredits == option.credits}
                                            onChange={handleSubCreditsChange}
                                        />
                                        <div>{option.label}</div>
                                    </div>
                                    <div className='planAmount'>${option.amount}</div>
                                </label>
                            </div>
                        ))}
                    </div>
                </div>}
                {!isFeatures && isTopUp && <div className="options-wrapper">
                    <div className='options-container'>
                        {ele.plans.map((option, index) => (
                            <div className='option-container'>
                                <label key={index} className="radio-label">
                                    <div className='lhs'>
                                        <input
                                            type="radio"
                                            name="pay-as-you-go-option" 
                                            value={option.credits}
                                            checked={numOfTopUpCredits == option.credits}
                                            onChange={handleTopUpCreditsChange}
                                        />
                                        <div>{option.label}</div>
                                    </div>
                                    <div className='planAmount'>${option.amount}</div>
                                </label>
                            </div>
                        ))}
                    </div>
                </div>}
                {!isFeatures && <div className={`upgradeDiv ${user?.isSlidesExtPremium ? '' : ''}`}><div className='upgradeBtn' onClick={async() => {
                    try {
                        //if (isIndianUser === null) return;
                        if(isSubscription && user?.isSlidesExtPremium){
                            handleManageSubscription();
                            return;
                        }

                        let finalPaymentLink = isSubscription ? subscriptionPayLink : isTopUp ? topUpPayLink : '';
                    
                        let paymentLink = `${finalPaymentLink}${finalPaymentLink.includes('?') ? '&' : '?'}checkout[custom][googleId]=${user?.googleId}&checkout[custom][source]=slides-extension`;
                        if(!user){
                            localStorage.setItem("pendingSheetsPlanLink", paymentLink);
                            initiateLogin();
                        }else{
                            //to notify backend whenever a user clicks BUY or SUBSCRIBE button
                                const actionType = isSubscription ? "Subscribe" : "Buy_TopUp";
                                const creditAmt = isSubscription ? numOfSubCredits : numOfTopUpCredits;
                                
                                // Background ping - no 'await', does not delay UI
                                axios.post(`${API_BASE_URL}/api/lemonsqueezy/checkout-intent`, {
                                    googleId: user?.googleId,
                                    plan: actionType,
                                    amount: creditAmt,
                                    source: "slides-extension"
                                }, { withCredentials: true }).catch(err => console.error(err));
                            //

                            window.LemonSqueezy.Url.Open(paymentLink);
                        }
                    } catch (err) {
                        isShowConsole && console.error('upgradeBtn upgrade failed:', err);
                        sentryLog(`PricingPage.js - upgradeBtn upgrade failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
                    }
                }}>{isSubscription ? (user?.isSlidesExtPremium ? "Manage Subscription" : "Subscribe") : "Buy Now"}</div><div className='paymentTrustNote'>🔒 Secure payment via Lemon Squeezy</div></div>}
                {/* {isTopUp && 
                    <div className='topUpNote'>
                        <span style={{fontWeight: 550}}>NOTE:</span> 
                        <br/>
                        <span style={{display: 'block', marginTop: '8px'}}>Top-up credits & Subscription credits are independent of each other.<span style={{display: 'block', marginTop: '5px', textDecoration: 'underline', color: 'blue', cursor: 'pointer'}} onClick={openTableOcrFAQPage}>Refer FAQ for more clarity</span></span>
                    </div>} */}
                {isFeatures && <div className='features' style={{height: 'auto'}}>
                    <ul>
                        {isFeatures && 
                            <>
                                {featuresList}
                            </>
                        } 
                    </ul>
                </div>}
                {/* {isFeatures && <div className='partitionNote'><div className='supportContainer'>
                        Have questions or feedback? <span className='chatCta' onClick={initateCrispChatbot}>Send a quick message</span>
                </div><div className='noteHeader'>IMPORTANT:</div><div className='noteContent'>Credits purchased on this page are exclusively for the Google Slides Extension <b>Convert PDF to Google Slides™</b>.</div></div>} */}
            </div>
        )
    }) : null;
    
    const initiateLogin = async () => {
      try{
            const query = getLqzyParams();
            await fetch(`${API_BASE_URL}/api/set-redirect`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include', // ✅ critical for session cookie
                body: JSON.stringify({ path: `/slides-extension-pricing${query}` })
            });
      
            window.location.href = `${API_BASE_URL}/auth/google`;
      }catch(err){
          isShowConsole && console.error('error in initiate login method: ', err);
          sentryLog(`PricingPage.js - initiateLogin failed: ${err?.message || err}`);
      }
    }
    
    return(
            <div className='parentDiv'>
                <div className='mainDiv pricingPage sheetsAddon'>
                    <div className='header'>
                        <ExtensionNavbar />
                    </div>
                    <div className='contentDiv'>
                        <div className='containerDiv'>
                            <div className='title'>
                                <div className='main'>Simple Pricing</div>
                                <div className='sub'>Pay only for what you need</div>
                            </div>
                            <div className='contentBox'>
                                <div className='content' style={{width: '91%'}}>
                                    {pricingElements}
                                </div>
                                <div className='infoNote'>
                                    Lock in now at the best rates! Prices may increase soon.
                                </div>
                            </div>
                        </div>
                    </div>
                    {showFeedbackPopup && <FeedbackPopup closeFeedbackPopup={() => setShowFeedbackPopup(false)}/>}
                </div>
                <FooterComponent forSlidesExtension={true} setShowFeedbackPopup={setShowFeedbackPopup}/>
            </div>
    )
}

export default SlidesExtensionPricingPage;